import { render, staticRenderFns } from "./store-campaign-details-history.vue?vue&type=template&id=871d2364"
import script from "./store-campaign-details-history.vue?vue&type=script&lang=js"
export * from "./store-campaign-details-history.vue?vue&type=script&lang=js"
import style0 from "./store-campaign-details-history.vue?vue&type=style&index=0&id=871d2364&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports